// extracted by mini-css-extract-plugin
export default {"ul":"index_ul_dRrKo","last":"index_last_MR-B7 index_ul_dRrKo"};